<div class="black-bg" fxLayout="column" fxLayoutAlign="space-evenly start">
    <div class="menu-title-container">
        <div class="menu-title">{{menu.title}}</div>
    </div>
    
    <app-menu-section *ngFor="let item of menu.items"
            [item]="item" 
            (submenuOpened)="handleSubmenuOpened($event)"></app-menu-section>
    
    <span class="example-fill-remaining-space">&nbsp;</span>

    <div *ngIf="menu.showFooter" class="menu-footer">
        <app-menu-section  [item]="menu.footerItem"></app-menu-section>
    </div>
   
</div>
